import { useEffect, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { omit } from 'ramda';

import { storageService } from '@core/js/services/storage.service';
import { getURLParams } from '@core/js/utils/url.util';

import { STORED_QUERY_PARAMS } from './constants';

export const useStoreQueryParam = () => {
    const history = useHistory();
    const { search } = useLocation();
    const params = getURLParams(search);
    const storedParamKeys = useMemo(() => Object.values(STORED_QUERY_PARAMS), []);

    useEffect(() => {
        let shouldRemoveParams = false;

        storedParamKeys.forEach((key) => {
            const param = params?.[key];

            if (param) {
                storageService.local.setItem(key, param);

                shouldRemoveParams = true;
            }
        });

        if (shouldRemoveParams) {
            history.replace({
                search: `?${new URLSearchParams(omit(storedParamKeys, params)).toString()}`
            });
        }
    }, [history, params, storedParamKeys]);
};
